import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { Users, ArrowRight, FileText } from "lucide-react";

const prefill = (message) => {
  window.dispatchEvent(new CustomEvent("prefill-contact", { detail: message }));
  document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
};

export default function WorkWithUs() {
  return (
    <section id="work-with-us" className="py-20 sm:py-28" data-testid="work-with-us-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center">
          <p className="text-sm font-bold tracking-[0.2em] uppercase text-[#FF5A5F]">Work With Us</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-[#222]">
            Partners Make This Work Possible
          </h2>
        </Reveal>

        <div className="mt-12 max-w-2xl mx-auto">
          <Reveal>
            <article
              data-testid="work-caseworkers-card"
              className="h-full flex flex-col bg-white border border-[#EBEBEB] rounded-2xl p-8 sm:p-10 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_24px_rgba(0,0,0,0.10)]"
            >
              <span className="inline-flex w-14 h-14 rounded-2xl bg-[#EDE9E1]/60 items-center justify-center">
                <Users className="w-7 h-7 text-[#E0484D]" />
              </span>
              <h3 className="mt-5 text-2xl font-bold text-[#222]">Caseworkers &amp; Community Partners</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-[#5a5a5a] flex-1">
                Helping someone find a room in the Orlando area or anywhere in Central Florida?
                Contact us to ask about openings or discuss a referral.
              </p>
              <button
                onClick={() => prefill("Hi, I'm a caseworker / community partner helping someone find housing. I'd like to ask about openings or discuss a referral.")}
                data-testid="work-referral-button"
                className="mt-6 inline-flex items-center justify-center gap-2 bg-[#FF5A5F] hover:bg-[#E0484D] text-white font-bold px-6 py-3.5 rounded-full transition-colors duration-200"
              >
                Contact Us About a Referral
                <ArrowRight className="w-4 h-4" />
              </button>
              <Link
                to="/referral"
                data-testid="work-flyer-link"
                className="mt-3 inline-flex items-center justify-center gap-2 bg-white border-2 border-[#EBEBEB] hover:border-[#FF5A5F] text-[#222] font-bold px-6 py-3 rounded-full text-sm transition-colors duration-200"
              >
                <FileText className="w-4 h-4 text-[#FF5A5F]" />
                Download Our Referral Flyer
              </Link>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
